import { createRouter, createWebHashHistory } from 'vue-router'

const routes = [
  {
    path: '/register',
    name: 'register',
    component: () => import('@/views/register/register'),
    meta: {
      title: '注册'
    }
  },
  {
    path: '/download/:brandId',
    name: 'download',
    component: () => import('@/views/register/download'),
    meta: {
      title: '下载'
    }
  },
  {
    path: '/agreement',
    name: 'agreement',
    component: () => import('@/views/user/agreement'),
    meta: {
      title: '用户协议'
    }
  },
  {
    path: '/privacy',
    name: 'privacy',
    component: () => import('@/views/user/privacy'),
    meta: {
      title: '用户隐私协议'
    }
  },
  {
    path: '/userPrivacy',
    name: 'userPrivacy',
    component: () => import('@/views/user/userPrivacy'),
    meta: {
      title: '用户隐私协议'
    }
  },
  {
    path: '/searchAgr',
    name: 'searchAgr',
    component: () => import('@/views/user/searchAgr'),
    meta: {
      title: '用户使用协议'
    }
  },
  {
    path: '/appinfoImg',
    name: 'appinfoImg',
    component: () => import('@/views/appinfoImg'),
    meta: {
    }
  },
  {
    path: '/paySuccess',
    name: 'paySuccess',
    component: () => import('@/views/payBack/success'),
    meta: {
      title: '支付成功'
    }
  },
  {
    path: '/monitor',
    name: 'monitor',
    component: () => import('@/views/adopt/monitor'),
    meta: {
      title: '监控'
    }
  },
  {
    path: '/monitorLive',
    name: 'monitorLive',
    component: () => import('@/views/adopt/monitorLive'),
    meta: {
      title: '监控'
    }
  },
  {
    path: '/guideBeginner',
    name: 'guideBeginner',
    component: () => import('@/views/GuideBeginner/index'),
    meta: {
      title: '新手引导'
    }
  },
  // {
  //   path: '/video',
  //   name: 'video',
  //   component: () => import('@/views/adopt/shtczh'),
  //   meta: {
  //     title: ''
  //   }
  // },
  {
    path: '/ceshi',
    name: 'ceshi',
    component: () => import('@/views/adopt/ceshi'),
    meta: {
      title: ''
    }
  },
  {
    path: '/captcha',
    name: 'captcha',
    component: () => import('@/views/captcha'),
    meta: {
      title: '获取验证码验证'
    }
  },
  {
    path: '/protect',
    name: 'protect',
    component: () => import('@/views/captcha/protect'),
    meta: {
      title: '获取验证码验证'
    }
  },
  {
    path: '/merchantPay',
    name: 'merchantPay',
    component: () => import('@/views/merchant/merchantPay'),
    meta: {
      title: '商户支付'
    }
  },
  {
    path: '/pushTwoReturnOne/rule',
    name: 'pushTwoReturnOneRule',
    component: () => import('@/views/PushTwoReturnOne/rule'),
    meta: {
      title: '规则说明'
    }
  },
  {
    path: '/customerService',
    name: 'customerService',
    component: () => import('@/views/PushTwoReturnOne/customerService'),
    meta: {
      title: '客服'
    }
  },
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

export default router
